export default "__VITE_ASSET__BqEOLLcL__"